import { AbstractControl, ValidatorFn } from '@angular/forms';


const dunsValidation = {
  'PIES_6_5': {
    'custom': function (): ValidatorFn {
      return (control: AbstractControl): {[key: string]: any} => {
        if (control.value && !(control.value.length === 9 || control.value.length === 13)) {
          return {'DUNS': 'Must be 9 or 13 characters long'};
        }
        return null;
      };
    },
  },
};

const glnValidation = {
  'PIES_6_5': {
    length: 13 ,
    message: 'GLN must be 13 character long ID drawn from the GS1 Company ID + Location ID + Check Digit, see www.gs1us.com'
  },
};

const vmrsValidation = {
  'PIES_6_5': {
    length: 5,
    message: 'VMRS ID must be 5 character long ID drawn from The Maintenance Council of the American Trucking Association'
  },
};

/* eslint-disable */
export const tradeInfoSegmentData: any = [
  // parent data
  {
    'field_map': 'parentName',
    'item_name': 'parent.name',
    'title': 'Parent name',
    'hint_detail': 'Parent name',
    'hint_panel' : 'Parent name',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
  },
  {
    'field_map': 'parentGLN',
    'item_name': 'parent_gln',
    'title': 'GLN',
    'hint_detail': 'Parent GLN',
    'hint_panel' : 'Parent GLN',
    'example': '',
    'sequence': 2,
    'show_more': true,
    'lookup': null,
    'validation': glnValidation,
  },
  {
    'field_map': 'parentDUNS',
    'item_name': 'parent_duns',
    'title': 'DUNS',
    'hint_detail': 'Parent DUNS or DUNS+4',
    'hint_panel' : 'Parent DUNS or DUNS+4',
    'example': '',
    'sequence': 3,
    'show_more': true,
    'lookup': null,
    'validation': dunsValidation,
  },
  {
    'field_map': 'parentVMRS',
    'item_name': 'parent_vmrs',
    'title': 'VMRS',
    'hint_detail': 'Parent VMRS ID',
    'hint_panel' : 'Parent VMRS ID',
    'example': '',
    'sequence': 4,
    'show_more': true,
    'lookup': null,
    'validation': vmrsValidation,
  },
  // owner data
  {
    'field_map': 'ownerName',
    'item_name': 'owner.name',
    'title': 'Owner name',
    'hint_detail': 'Owner name',
    'hint_panel' : 'Owner name',
    'example': '',
    'sequence': 5,
    'show_more': true,
    'lookup': null,
  },
  {
    'field_map': 'ownerGLN',
    'item_name': 'owner_gln',
    'title': 'GLN',
    'hint_detail': 'Owner GLN',
    'hint_panel' : 'Owner GLN',
    'example': '',
    'sequence': 6,
    'show_more': true,
    'lookup': null,
    'validation': glnValidation,
  },
  {
    'field_map': 'ownerDUNS',
    'item_name': 'owner_duns',
    'title': 'DUNS',
    'hint_detail': 'Owner DUNS',
    'hint_panel' : 'Owner DUNS',
    'example': '',
    'sequence': 7,
    'show_more': true,
    'lookup': null,
    'validation': dunsValidation,
  },
  {
    'field_map': 'ownerVMRS',
    'item_name': 'owner_vmrs',
    'title': 'VMRS',
    'hint_detail': 'Owner VMRS ID',
    'hint_panel' : 'Owner VMRS ID',
    'example': '',
    'sequence': 8,
    'show_more': true,
    'lookup': null,
    'validation': vmrsValidation,
  },
  // brand data
  {
    'field_map': 'brandName',
    'item_name': 'brand.name',
    'title': 'Brand name',
    'hint_detail': 'Brand name',
    'hint_panel' : 'Brand name',
    'example': '',
    'sequence': 9,
    'show_more': true,
    'lookup': null,
  },
];

/* eslint-enable */
